import { render, staticRenderFns } from "./SeeMoreButton.vue?vue&type=template&id=b57db97e&scoped=true"
import script from "./SeeMoreButton.vue?vue&type=script&lang=js"
export * from "./SeeMoreButton.vue?vue&type=script&lang=js"
import style0 from "./SeeMoreButton.vue?vue&type=style&index=0&id=b57db97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57db97e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SecondaryLoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/SecondaryLoadingSpinner.vue').default})
